/**
 * Intelligence Centre — a dedicated page embedding the Wolfox Intelligence
 * archive: a searchable, filterable repository of monitored regulatory and
 * policy intelligence. The widget renders and drives all search/filter/sort
 * UI inside its own iframe; the portal just provides the page and container.
 *
 * @returns {JSX.Element}
 */
import React from 'react';
import WolfoxWidget from '../components/Wolfox/WolfoxWidget';

function IntelligenceCentre() {
  return (
    <div className="totalPage">
      <section className="wrapper">
        <div className="container mt-4">
          <WolfoxWidget type="intelligence" />
        </div>
      </section>
    </div>
  );
}

export default IntelligenceCentre;
